import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getSelectedCustomer } from 'selectors/tools';
import DTCustomerAccountView from '../../DTCustomerAccountView';
import { isEmpty } from 'lodash';
import { checkAccountReinstateAndAddDTEdge } from 'actions/tools/DecisionTree/accountSearchActions';
import { getSimplrAccountIdOfSelectedTicket } from 'extractFromState';
import { setLoading as setLoadingAction } from 'actions';

const DTSelectCustomerToReinstateAccount = () => {
  const dispatch = useDispatch();
  const selectedCustomer = useSelector(getSelectedCustomer);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const setLoading = useCallback((loading) => dispatch(setLoadingAction(loading, 'DTCustomerAccountView')), [dispatch]);

  const handleNextButtonClick = async () => {
    setLoading(true);
    await dispatch(checkAccountReinstateAndAddDTEdge(selectedCustomer.customerId, simplrAccountId));
    setLoading(false);
  };

  return (
    <DTCustomerAccountView onNextButtonClick={handleNextButtonClick} isNextButtonActive={!isEmpty(selectedCustomer)} />
  );
};

export default DTSelectCustomerToReinstateAccount;
